import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectELTVersion = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.eltVersion
)
